import { Divider, Header } from 'semantic-ui-react'
import { Section } from '../Shared/Section'
import { CheckoutSystemCard } from './Cards/CheckoutSystemCard/CheckoutSystemCard'
import { DevicesCard } from './Cards/DevicesCard/DevicesCard'

const IntegrationSection = () => {
    return (
      <>
          <Divider horizontal>
              <Header as="h4" color="teal">
                  Intégrations
              </Header>
          </Divider>

          <Section>
              <CheckoutSystemCard />
              <DevicesCard />
          </Section>
      </>
    )
}

export { IntegrationSection }
